import { render, staticRenderFns } from "./PublicationLocationItem.vue?vue&type=template&id=7139d90e&scoped=true&lang=pug&"
import script from "./PublicationLocationItem.vue?vue&type=script&lang=js&"
export * from "./PublicationLocationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7139d90e",
  null
  
)

export default component.exports